DOMReady( function(){
  /* ========================================================================
  * Show panorama image
  * ======================================================================== */
  [... document.querySelectorAll('.panorama-inside')].map( panoramaEl => {
    pannellum.viewer( panoramaEl.id, {
      "type": "equirectangular",
      "panorama": panoramaEl.dataset.panoramic,
      "preview" : panoramaEl.dataset.preview,
      "mouseZoom" : panoramaEl.dataset.zoom,
      "hfov": 120,
      "strings" : {
        "loadButtonLabel" : "Cliquez ici<br/>pour voir</br> la photo en 360°",
        "loadingLabel": "Chargement ...",
        "fileAccessError": "Erreur chargement de l'image"
      },
      "autoLoad": (panoramaEl.dataset.autoplay && panoramaEl.dataset.autoplay == 1 )? true : false,
      "autoRotate": (panoramaEl.dataset.rotation && panoramaEl.dataset.rotation == 1 )? 5 : false
    });
  });
});